import { useEffect, useState, useMemo } from "react"
import { fetchUsersByIds } from "@/lib/chatData"
import type { ChatUserInfo } from "@/lib/chatData"

export function useUsers(userIds: string[]) {
  const [users, setUsers] = useState<ChatUserInfo[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  // Memoize the userIds to prevent infinite re-renders
  const memoizedUserIds = useMemo(() => userIds, [userIds.join(',')])

  useEffect(() => {
    if (memoizedUserIds.length === 0) {
      setUsers([])
      setLoading(false)
      return
    }

    setLoading(true)
    fetchUsersByIds(memoizedUserIds)
      .then(setUsers)
      .catch(err => {
        console.error("Failed to load users", err)
        setError(err)
      })
      .finally(() => setLoading(false))
  }, [memoizedUserIds])

  return { users, loading, error }
} 